import { spacingHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { PropertyGridTile, PropertyTileProps } from '../PropertyTile/PropertyTile';
import { ContentBrickWrapper } from '../ContentBrick/ContentBrick';

interface PropertiesCollectionBrickProps {
  properties: PropertyTileProps[];
}

const BrickWrapper = styled(ContentBrickWrapper)`
  padding-top: ${spacingHelper('large')};
  padding-bottom: ${spacingHelper('large')};
`;

const TileWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const PropertiesCollectionBrick: FunctionComponent<PropertiesCollectionBrickProps> = ({
  properties,
}) => {
  if (!properties.length) return null;
  return (
    <BrickWrapper>
      <TileWrapper>
        {properties.map(
          ({ path, clickThroughSource, image, badge, title, subtitle, features }, index) => {
            return (
              <PropertyGridTile
                path={path}
                clickThroughSource={clickThroughSource}
                image={image}
                badge={badge}
                title={title}
                titleAs="h2"
                subtitle={subtitle}
                features={features}
                key={index}
              />
            );
          },
        )}
      </TileWrapper>
    </BrickWrapper>
  );
};
